module.exports = __webpack_public_path__ + "img/mpascensores-login.42569c47.png";